
/**
 * 
 * @export
 * @interface BannerPublicResponse
 */
export interface BannerPublicResponse {
    /**
     * 
     * @type {string}
     * @memberof BannerPublicResponse
     */
    'bannerTyp'?: BannerPublicResponseBannerTypEnum;
    /**
     * 
     * @type {string}
     * @memberof BannerPublicResponse
     */
    'text'?: string;
}

export const BannerPublicResponseBannerTypEnum = {
    Info: 'INFO',
    Warning: 'WARNING',
    Success: 'SUCCESS'
} as const;

export type BannerPublicResponseBannerTypEnum = typeof BannerPublicResponseBannerTypEnum[keyof typeof BannerPublicResponseBannerTypEnum];


